export class BudgetCostReq {
    id:number
    departmentName:string
    budgetPeriod:string
    fromDate:any
    toDate:any
    budget:number
    cost:number
    year:any
}